import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
//#region src/components/icons/Expand06Icon.tsx
var i = (e) => /* @__PURE__ */ n(t, {
	viewBox: "0 0 24 24",
	fill: "none",
	...e,
	children: /* @__PURE__ */ n("path", {
		d: "M7.29297 15.293C7.68349 14.9024 8.31651 14.9024 8.70703 15.293C9.09756 15.6835 9.09756 16.3165 8.70703 16.707L5.41406 20H8C8.55228 20 9 20.4477 9 21C9 21.5523 8.55228 22 8 22H3C2.44772 22 2 21.5523 2 21V16C2 15.4477 2.44772 15 3 15C3.55228 15 4 15.4477 4 16V18.5859L7.29297 15.293ZM15.293 15.293C15.6835 14.9024 16.3165 14.9024 16.707 15.293L20 18.5859V16C20 15.4477 20.4477 15 21 15C21.5523 15 22 15.4477 22 16V21C22 21.5523 21.5523 22 21 22H16C15.4477 22 15 21.5523 15 21C15 20.4477 15.4477 20 16 20H18.5859L15.293 16.707C14.9024 16.3165 14.9024 15.6835 15.293 15.293ZM2 8V3C2 2.44772 2.44772 2 3 2H8C8.55228 2 9 2.44772 9 3C9 3.55228 8.55228 4 8 4H5.41406L8.70703 7.29297C9.09756 7.68349 9.09756 8.31651 8.70703 8.70703C8.31651 9.09756 7.68349 9.09756 7.29297 8.70703L4 5.41406V8C4 8.55228 3.55228 9 3 9C2.44772 9 2 8.55228 2 8ZM22 8C22 8.55228 21.5523 9 21 9C20.4477 9 20 8.55228 20 8V5.41406L16.707 8.70703C16.3165 9.09756 15.6835 9.09756 15.293 8.70703C14.9024 8.31651 14.9024 7.68349 15.293 7.29297L18.5859 4H16C15.4477 4 15 3.55228 15 3C15 2.44772 15.4477 2 16 2H21C21.5523 2 22 2.44772 22 3V8Z",
		fill: "currentColor"
	})
}), a = {
	12: {
		Artwork: i,
		width: 12,
		height: 12
	},
	16: {
		Artwork: (e) => /* @__PURE__ */ r(t, {
			viewBox: "0 0 16 16",
			fill: "none",
			...e,
			children: [
				/* @__PURE__ */ n("path", {
					d: "M4.80273 10.1367C5.09563 9.84383 5.57039 9.84383 5.86328 10.1367C6.15617 10.4296 6.15617 10.9044 5.86328 11.1973L3.81055 13.25H5.33301C5.74722 13.25 6.08301 13.5858 6.08301 14C6.08301 14.4142 5.74722 14.75 5.33301 14.75H2C1.58579 14.75 1.25 14.4142 1.25 14V10.667C1.25 10.2528 1.58579 9.91699 2 9.91699C2.41421 9.91699 2.75 10.2528 2.75 10.667V12.1895L4.80273 10.1367Z",
					fill: "currentColor"
				}),
				/* @__PURE__ */ n("path", {
					d: "M14 9.91699C14.4142 9.91699 14.75 10.2528 14.75 10.667V14C14.75 14.4142 14.4142 14.75 14 14.75H10.667C10.2528 14.75 9.91699 14.4142 9.91699 14C9.91699 13.5858 10.2528 13.25 10.667 13.25H12.1895L10.1367 11.1973C9.84382 10.9044 9.84382 10.4296 10.1367 10.1367C10.4296 9.84382 10.9044 9.84382 11.1973 10.1367L13.25 12.1895V10.667C13.25 10.2528 13.5858 9.91699 14 9.91699Z",
					fill: "currentColor"
				}),
				/* @__PURE__ */ n("path", {
					d: "M5.33301 1.25C5.74722 1.25 6.08301 1.58579 6.08301 2C6.08301 2.41421 5.74722 2.75 5.33301 2.75H3.81055L5.86328 4.80273C6.15617 5.09563 6.15617 5.57039 5.86328 5.86328C5.57039 6.15617 5.09563 6.15617 4.80273 5.86328L2.75 3.81055V5.33301C2.75 5.74722 2.41421 6.08301 2 6.08301C1.58579 6.08301 1.25 5.74722 1.25 5.33301V2C1.25 1.58579 1.58579 1.25 2 1.25H5.33301Z",
					fill: "currentColor"
				}),
				/* @__PURE__ */ n("path", {
					d: "M14 1.25C14.4142 1.25 14.75 1.58579 14.75 2V5.33301C14.75 5.74722 14.4142 6.08301 14 6.08301C13.5858 6.08301 13.25 5.74722 13.25 5.33301V3.81055L11.1973 5.86328C10.9044 6.15617 10.4296 6.15617 10.1367 5.86328C9.84383 5.57039 9.84383 5.09563 10.1367 4.80273L12.1895 2.75H10.667C10.2528 2.75 9.91699 2.41421 9.91699 2C9.91699 1.58579 10.2528 1.25 10.667 1.25H14Z",
					fill: "currentColor"
				})
			]
		}),
		width: 16,
		height: 16
	},
	20: {
		Artwork: i,
		width: 20,
		height: 20
	},
	24: {
		Artwork: i,
		width: 24,
		height: 24
	}
}, o = ({ size: t = 16, tone: r = "default", className: i, ...o }) => /* @__PURE__ */ n(e, {
	source: a[t],
	monochrome: !0,
	className: ["pf-icon-" + r, i].filter(Boolean).join(" "),
	...o
});
//#endregion
export { o as Expand06Icon };
